import Typography from "@/shared/ui/Typography";
import { ImageSlider } from "@/widgets/sliders/image_slider/ui/ImageSlider";

export interface IProjectMainSectionProps {
    description: string;
    images: string[];
    price: number;
    area: number;
    floors: number;
    complated: string;
}

export function AboutSection({
    description,
    images,
    price,
    area,
    floors,
    complated,
}: IProjectMainSectionProps) {
    return (
        <section className="flex flex-col gap-[20px] md:gap-[32px] py-[40px] md:py-[52px]">
            <div className="container flex flex-col gap-[20px] md:gap-[32px]">
                <div className="flex flex-col md:items-center md:justify-between md:flex-row gap-[12px] md:gap-[26px]">
                    <Typography className="whitespace-nowrap uppercase font-bold text-[20px] md:text-[26px]">
                        О проекте
                    </Typography>

                    <div className="flex flex-wrap md:flex-nowrap gap-[4px] md:gap-[8px] md:items-center">
                        <div 
                            className=" whitespace-nowrap text-[10px] h-[31px] md:h-[34px] flex items-center md:text-[14px] font-manrope font-normal px-[12px] bg-white-10 gradient-white-bg rounded-[20px]"
                        >
                            от {price} ₽/М²
                        </div>
                        <div 
                            className="whitespace-nowrap text-[10px] h-[31px] md:h-[34px] flex items-center md:text-[14px] font-manrope font-normal px-[12px] bg-white-10 gradient-white-bg rounded-[20px]"
                        >
                            Площадь от {area} М²
                        </div>
                        <div 
                            className="whitespace-nowrap text-[10px] h-[31px] md:h-[34px] flex items-center md:text-[14px] font-manrope font-normal px-[12px] bg-white-10 gradient-white-bg rounded-[20px]"
                        >
                            {floors} этажа
                        </div>
                        <div 
                            className="whitespace-nowrap text-[10px] h-[31px] md:h-[34px] flex items-center md:text-[14px] font-manrope font-normal px-[12px] bg-white-10 gradient-white-bg rounded-[20px]"
                        >
                            Готовность {complated} г
                        </div>
                    </div>
                </div>

                <Typography className="uppercase !leading-[120%] font-semibold text-[16px] md:text-[18px] xl:text-[26px]">
                    {description}
                </Typography>
            </div>

            <ImageSlider
                images={images}
            />
        </section>
    );
}
